import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { FocusTrapModule } from 'primeng/focustrap';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';

import { HisSearchResultTestComponent } from './component/his-search-result-test.component';
import { HisSearchResultComponent } from './component/his-search-result.component';
import {
    HisSearchCriteriagroupComponent,
    HisSearchFormComponent,
    HisSearchFormResultComponent,
    HisSearchFormWidgetComponent,
    HisSearchSelectComponent,
    HisSearchSelectPopupComponent
} from './component/his-search.component';

import { HisSearchAutocompleteComponent } from './component/his-search-autocomplete.component';
import { HisSearchCalendarComponent } from './component/his-search-calendar.component';
import { HisSearchCheckboxComponent } from './component/his-search-checkbox.component';
import { HisSearchInputComponent } from './component/his-search-input.component';
import { HisSearchMultiselectComponent } from './component/his-search-multiselect.component';
import { HisSearchSaveParamsComponent } from './component/his-search-save-params.component';
import { HisSearchSelectAutocompleteComponent } from './component/his-search-select-autocomplete.component';
import { HisSearchSelectOperatorComponent } from './component/his-search-select-operator.component';
import { HisSearchTreeSelectComponent } from './component/his-search-tree-select.component';

import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisDisplaySharedModule } from '../display/his-display-shared.module';
import { HisInputSharedModule } from '../input/his-input-shared.module';
import { HisJobsSharedModule } from '../jobs/his-jobs-shared.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';
import { HisTreeSharedModule } from '../tree/his-tree-shared.module';
import { HisSearchResultSearchInfoComponent } from './component/his-search-result-search-info.component';

import { TabsModule } from 'primeng/tabs';
import { HisTableSharedModule } from '../table/his-table-shared.module';
import { HisMultiSearchResultComponent } from './component/his-multi-search-result.component';
import { HisSearchFormColumnComponent } from './component/his-search-form-column.component';
import { HisSearchPrintviewComponent } from './component/his-search-printview.component';
import { HisSearchResultConfigComponent } from './component/his-search-result-config.component';
import { HisSearchResultListComponent } from './component/his-search-result-list.component';
import { HisSearchResultSelectButtonsComponent } from './component/his-search-result-select-buttons.component';
import { HisSearchResultSelectedItemsComponent } from './component/his-search-result-selected-items.component';
import { HisSearchResultTableCellComponent } from './component/his-search-result-table-cell.component';

/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        // primeng
        TableModule,
        DataViewModule,
        DialogModule,
        PanelModule,
        TreeTableModule,
        OverlayPanelModule,
        AutoCompleteModule,
        CalendarModule,
        FocusTrapModule,
        TabsModule,

        // HIS
        HisCoreSharedModule,
        HisDisplaySharedModule,
        HisTreeSharedModule,
        HisInputSharedModule,
        HisStructureSharedModule,
        HisJobsSharedModule,
        PaginatorModule,
        HisTableSharedModule,
    ],

    declarations: [
        HisSearchFormComponent,
        HisSearchFormWidgetComponent,
        HisSearchCriteriagroupComponent,
        HisSearchResultComponent,
        HisSearchResultTestComponent,
        HisSearchFormResultComponent,

        HisSearchFormColumnComponent,
        HisSearchInputComponent,
        HisSearchCheckboxComponent,
        HisSearchCalendarComponent,
        HisSearchAutocompleteComponent,
        HisSearchMultiselectComponent,
        HisSearchSelectComponent,
        HisSearchTreeSelectComponent,
        HisSearchSelectPopupComponent,
        HisSearchSelectAutocompleteComponent,
        HisSearchSaveParamsComponent,
        HisSearchSelectOperatorComponent,
        HisSearchResultSearchInfoComponent,
        HisSearchResultConfigComponent,
        HisSearchPrintviewComponent,
        HisSearchResultTableCellComponent,
        HisSearchResultSelectedItemsComponent,
        HisSearchResultSelectButtonsComponent,
        HisSearchResultListComponent,
        HisMultiSearchResultComponent
    ],

    exports: [
        HisSearchFormComponent,
        HisSearchResultComponent,
        HisSearchFormResultComponent,
        HisSearchSelectComponent,
        HisSearchSelectPopupComponent,
        HisSearchTreeSelectComponent,
        HisSearchResultSearchInfoComponent,
        HisSearchResultConfigComponent,
        HisSearchResultTableCellComponent,
        HisSearchResultListComponent,
        HisMultiSearchResultComponent
    ]
    // NO PROVIDERS! Providers need to go into HisGenericsearchCoreModule
} )
export class HisGenericsearchSharedModule {

}
